import { createQuery } from '../api/query'
import { APIFlowEntityResponse, IFlowEntity } from './types'

export const keyFlowEntities = (arg: string) => [`/flow-entities`, arg]
export const useQueryFlowEntities = createQuery<APIFlowEntityResponse>({
    key: keyFlowEntities,
    url: '/flow-entities',
})

const keyFlowEntity = (arg: string) => [`/flow-entity`, arg]
export const useQueryFlowEntity = createQuery<IFlowEntity>({
    key: keyFlowEntity,
    url: '/flow-entity',
})
